<style>
@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Accounts" title="Bank Accounts" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
							<div class="col-md-12 project-list filter-sort">
								<div class="row align-items-end">
									<div class="col-md-6 d-flex mt-2">
										<label class="d-flex listing-length ms-1 align-items-center">
											<span>Show</span>
											<select class="form-select mx-2" style="width: auto" v-model="listing_length" @change="fetchBankAccounts()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-4 mt-2">
										<input type="text" class="form-control" placeholder="Search by bank name, account…" v-model="keyword" @keyup="fetchBankAccounts()" />
									</div>
									<div class="col-md-2 mt-2 text-end">
										<button type="button" class="btn btn-primary" @click="openAddModal">Add account</button>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table mt-3">
								<table class="display table">
									<thead>
										<tr align="center">
											<th>Sl.No</th>
											<th>Bank name</th>
											<th>Account no.</th>
											<th>IFSC</th>
											<th>Branch</th>
											<th>Status</th>
											<th>Updated</th>
											<th>Actions</th>
										</tr>
									</thead>
									<tbody v-if="accounts.length">
										<tr align="center" v-for="(row, index) in accounts" :key="row.id">
											<td>{{ from != null ? from + index : index + 1 }}</td>
											<td class="text-start">{{ row.bank_name }}</td>
											<td>{{ row.account_number }}</td>
											<td>{{ row.ifsc_code || "—" }}</td>
											<td>{{ row.branch || "—" }}</td>
											<td>
												<span class="badge rounded-pill bg-success" v-if="row.status == 1">Active</span>
												<span class="badge rounded-pill bg-secondary" v-else>Inactive</span>
											</td>
											<td>{{ row.updated_at ? $filters.formatDate(row.updated_at) : "—" }}</td>
											<td>
												<button type="button" class="btn btn-sm btn-info mb-1 ms-1" @click="goTransactions(row)">Transactions</button>
												<button type="button" class="btn btn-sm btn-warning mb-1 ms-1" @click="openEditModal(row)">Edit</button>
											</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="8" align="center">No bank accounts found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<caption v-if="accounts.length" class="float-start mt-2 d-block">Showing {{ from }} to {{ to }} of {{ total }} entries</caption>
							<nav v-if="accounts.length && pagination.length" aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination mb-0">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="'p-' + index + '-' + page.label">
										<a
											class="page-link"
											href="#"
											@click.prevent="onPageClick(page, index)"
											tabindex="-1"
										>
											<span v-if="index === 0">Prev</span>
											<span v-else-if="index === pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title="modal_title">
			<template #body>
				<form @submit.prevent="saveAccount">
					<div class="row">
						<div class="col-md-12 form-group mt-2">
							<label class="control-label">Bank name<span class="text-danger">*</span></label>
							<input class="form-control" type="text" v-model="form.bank_name" placeholder="Enter bank name" />
							<div v-if="errors.bank_name" class="text-danger small">{{ errors.bank_name }}</div>
						</div>
						<div class="col-md-12 form-group mt-2">
							<label class="control-label">Account number</label>
							<input class="form-control" type="text" v-model="form.account_number" placeholder="Account number" />
							<div v-if="errors.account_number" class="text-danger small">{{ errors.account_number }}</div>
						</div>
						<div class="col-md-12 form-group mt-2">
							<label class="control-label">IFSC code</label>
							<input class="form-control" type="text" v-model="form.ifsc_code" placeholder="IFSC" />
							<div v-if="errors.ifsc_code" class="text-danger small">{{ errors.ifsc_code }}</div>
						</div>
						<div class="col-md-12 form-group mt-2">
							<label class="control-label">Branch</label>
							<input class="form-control" type="text" v-model="form.branch" placeholder="Branch" />
							<div v-if="errors.branch" class="text-danger small">{{ errors.branch }}</div>
						</div>
						<div class="col-md-12 form-group mt-2">
							<label class="control-label">Closing balance</label>
							<input class="form-control" type="number" min="0" step="0.01" v-model="form.closing_balance" placeholder="0.00" />
							<div v-if="errors.closing_balance" class="text-danger small">{{ errors.closing_balance }}</div>
						</div>
					</div>

					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-2" :disabled="loading">
							<span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
							{{ loading ? "Saving..." : button_title }}
						</button>
						<button type="button" class="btn btn-light" @click="closeModal" :disabled="loading">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>
	</div>
</template>

<script>
import { onMounted } from "vue";
import { Modal } from "bootstrap";
import DynamicModal from "@/components/dynamic_modal.vue";

let dynamicmodal;

export default {
	name: "BankAccounts",
	components: { DynamicModal },
	setup() {
		onMounted(() => {
			const el = document.getElementById("dynamicmodal");
			if (el) dynamicmodal = new Modal(el);
		});
		return {
			showModal: () => dynamicmodal && dynamicmodal.show(),
			hideModal: () => dynamicmodal && dynamicmodal.hide(),
		};
	},
	data() {
		return {
			token: "",
			keyword: "",
			listing_length: 10,
			accounts: [],
			pagination: [],
			from: 0,
			to: 0,
			total: 0,
			active_page_url: "",
			loading: false,
			modal_title: "Add bank account",
			button_title: "Save",
			editingId: null,
			errors: {},
			form: {
				bank_name: "",
				account_number: "",
				ifsc_code: "",
				branch: "",
				closing_balance: "",
			},
		};
	},
	created() {
		this.fetchBankAccounts();
	},
	methods: {
		getToken() {
			const raw = localStorage.getItem("airotrack_staff");
			if (!raw) {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
				return;
			}
			const airotrack_staff = JSON.parse(raw);
			if (!airotrack_staff.token) {
				this.$swal("", "Failed to fetch token, please login again", "error");
				this.$router.push({ name: "login" });
				return;
			}
			this.token = airotrack_staff.token;
		},

		listUrl() {
			return `/staffs/airoBankAccounts?limit=${this.listing_length}&keyword=${encodeURIComponent(this.keyword || "")}`;
		},

		fetchBankAccounts(pageUrl) {
			this.getToken();
			const url = pageUrl || this.listUrl();
			this.active_page_url = url;
			this.$axios
				.get(url, { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					if (res.data.status !== "true" && res.data.status !== true) {
						this.accounts = [];
						this.pagination = [];
						return;
					}
					const paginator = res.data.data?.bankAccounts;
					if (!paginator) {
						this.accounts = [];
						this.pagination = [];
						return;
					}
					this.accounts = paginator.data || [];
					this.pagination = paginator.links || [];
					this.from = paginator.from ?? 0;
					this.to = paginator.to ?? 0;
					this.total = paginator.total ?? 0;
				})
				.catch((err) => {
					console.error(err);
					this.$swal("Error", err.response?.data?.message || "Failed to load bank accounts", "error");
					this.accounts = [];
					this.pagination = [];
				});
		},

		onPageClick(page, index) {
			if (!page.url) return;
			const base = page.url;
			const sep = base.includes("?") ? "&" : "?";
			this.fetchBankAccounts(`${base}${sep}limit=${this.listing_length}&keyword=${encodeURIComponent(this.keyword || "")}`);
		},

		resetForm() {
			this.form = {
				bank_name: "",
				account_number: "",
				ifsc_code: "",
				branch: "",
				closing_balance: "",
			};
			this.errors = {};
			this.editingId = null;
		},

		openAddModal() {
			this.resetForm();
			this.modal_title = "Add bank account";
			this.button_title = "Save";
			this.loading = false;
			this.showModal();
		},

		goTransactions(row) {
			this.$router.push({ name: "bank_account_transactions", params: { bank_id: row.id } });
		},

		openEditModal(row) {
			this.resetForm();
			this.editingId = row.id;
			this.form.bank_name = row.bank_name || "";
			this.form.account_number = row.account_number || "";
			this.form.ifsc_code = row.ifsc_code || "";
			this.form.branch = row.branch || "";
			this.form.closing_balance = row.closing_balance != null && row.closing_balance !== "" ? row.closing_balance : "";
			this.modal_title = "Edit bank account";
			this.button_title = "Update";
			this.loading = false;
			this.showModal();
		},

		closeModal() {
			this.hideModal();
			this.resetForm();
		},

		validateForm() {
			this.errors = {};
			if (!this.form.bank_name || String(this.form.bank_name).trim() === "") {
				this.errors.bank_name = "Bank name is required";
				return false;
			}
			return true;
		},

		/** Backend may return message as a string or a validation map like { field: ["msg"] }. */
		extractMessage(message) {
			if (!message) return "";
			if (typeof message === "string") return message;
			if (Array.isArray(message)) return String(message[0] ?? "");
			if (typeof message === "object") {
				const first = Object.values(message)[0];
				if (Array.isArray(first)) return String(first[0] ?? "");
				return String(first ?? "");
			}
			return String(message);
		},

		applyFieldErrors(source) {
			if (!source || typeof source !== "object" || Array.isArray(source)) return;
			Object.keys(source).forEach((k) => {
				const v = source[k];
				this.errors[k] = Array.isArray(v) ? v[0] : v;
			});
		},

		handleApiError(errorOrResponse) {
			const data = errorOrResponse?.response?.data ?? errorOrResponse?.data ?? errorOrResponse;
			const fieldErrors = data?.errors;
			const message = data?.message;

			if (fieldErrors && typeof fieldErrors === "object" && !Array.isArray(fieldErrors)) {
				this.applyFieldErrors(fieldErrors);
			}
			if (message && typeof message === "object" && !Array.isArray(message)) {
				this.applyFieldErrors(message);
			}

			return this.extractMessage(message) || this.extractMessage(fieldErrors) || "Something went wrong";
		},

		saveAccount() {
			if (this.loading) return;
			if (!this.validateForm()) return;

			this.loading = true;
			this.getToken();

			const payload = {
				bank_name: String(this.form.bank_name).trim(),
				account_number: this.form.account_number ? String(this.form.account_number).trim() : "",
				ifsc_code: this.form.ifsc_code ? String(this.form.ifsc_code).trim() : "",
				branch: this.form.branch ? String(this.form.branch).trim() : "",
			};
			if (this.form.closing_balance !== "" && this.form.closing_balance != null) {
				payload.closing_balance = Number(this.form.closing_balance);
			}

			const url = this.editingId ? "/staffs/updateBankAccount" : "/staffs/addBankAccount";
			if (this.editingId) payload.id = this.editingId;

			this.$axios
				.post(url, payload, {
					headers: {
						Authorization: "Bearer " + this.token,
						"Content-Type": "application/json",
					},
				})
				.then((response) => {
					const ok = response.data.status === true || response.data.status === "true";
					if (ok) {
						this.$swal("Success", this.extractMessage(response.data.message) || "Saved successfully", "success");
						this.closeModal();
						this.fetchBankAccounts(this.active_page_url || this.listUrl());
					} else {
						this.$swal("Error", this.handleApiError(response), "error");
					}
				})
				.catch((error) => {
					this.$swal("Error", this.handleApiError(error), "error");
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},
};
</script>
